@if (isVisible && uploads.length > 0) {
  <div
    class="upload-widget"
    [class.collapsed]="isCollapsed"
    cdkDrag
    cdkDragBoundary="body"
    [cdkDragFreeDragPosition]="dragPosition"
  >
    <!-- ── Header ── -->
    <div class="upload-header" cdkDragHandle>
      <div class="header-left">
        <span class="header-title">{{ uploadSummary.title }}</span>
        <span class="header-count">{{ uploadSummary.badge }}</span>
      </div>

      <div class="header-actions">
        <button
          class="icon-btn"
          (click)="toggleCollapse()"
          [title]="isCollapsed ? 'Expand' : 'Collapse'"
        >
          <svg
            width="13" height="8" viewBox="0 0 13 8" fill="none"
            [class.rotated]="isCollapsed"
          >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.071 0.292769L12.728 5.94977L11.314 7.36377L6.364 2.41377L1.414 7.36377L0 5.94977L5.657 0.292769C5.84453 0.105298 6.09884 -1.75671e-05 6.364 -1.75671e-05C6.62917 -1.75671e-05 6.88347 0.105298 7.071 0.292769Z" fill="white"/>
          </svg>
        </button>
        <button class="icon-btn" (click)="closeWidget()" title="Close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="white"/>
          </svg>
        </button>
      </div>

      <!-- ── Mobile collapsed FAB — only shown on mobile when collapsed ── -->
      <button class="mobile-fab-btn" (click)="toggleCollapse()" title="Show uploads">
        <span class="fab-ring"></span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
        </svg>
      </button>
    </div>

    <!-- ── Upload list ── -->
    @if (!isCollapsed) {
      <div class="upload-list">
        @for (item of uploads; track item.id) {
          <div class="upload-item">
            <!-- Left: file info -->
            <div class="item-info">
              <span class="file-name" [title]="item.fileName">{{ item.fileName }}</span>
              <span class="status-label">{{ getStatusLabel(item) }}</span>
            </div>

            <!-- Right: progress + status icon + abort -->
            <div class="item-right">

              <!-- CSV: count mode → "567 / 1000"  (backend provides record counts) -->
              @if (item.fileType === 'csv' && item.csvDisplayMode === 'count') {
                <span class="record-count" [class.muted]="isTerminal(item.status)">
                  {{ item.processedRecords ?? 0 }}/{{ item.totalRecords ?? '?' }}
                </span>
              }

              <!-- CSV: percentage mode (default) OR non-CSV → "45%" -->
              @if (item.fileType !== 'csv' || item.csvDisplayMode === 'percentage') {
                <span class="percent" [class.muted]="isTerminal(item.status)">
                  {{ item.progress }}%
                </span>
              }

              <!-- Status icon -->
              <span class="status-icon" [ngClass]="'status-' + item.status">
                @switch (item.status) {
                  @case ('completed') {
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <circle cx="9" cy="9" r="9" fill="#22C55E"/>
                      <path d="M5 9L7.5 11.5L13 6.5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                  @case ('failed') {
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <circle cx="9" cy="9" r="9" fill="#EF4444"/>
                      <path d="M6 6L12 12M12 6L6 12" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                    </svg>
                  }
                  @case ('aborted') {
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <circle cx="9" cy="9" r="9" fill="#9CA3AF"/>
                      <path d="M6 9H12" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  }
                  @default {
                    <!-- Spinner for uploading / processing -->
                    <span class="spinner"></span>
                  }
                }
              </span>

              <!-- Abort button: CSV only, while active -->
              @if (item.fileType === 'csv' && isActive(item.status)) {
                <button
                  class="abort-btn"
                  (click)="abortUpload(item.id)"
                  title="Abort upload"
                >
                  Abort
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
